import { useSelector } from 'react-redux';

import {
  selectHasFailed,
  selectIsUploadingFile,
  selectProgressForCurrentUploads,
  selectUploadErrorMessage,
} from 'modules/files/selectors';
import LocalizedStrings from '../localization';

const useFileUploadStatus = (): [boolean, string, boolean, string] => {
  const isUploading = useSelector(selectIsUploadingFile);
  const uploadProgress = useSelector(selectProgressForCurrentUploads);
  const hasFailed = useSelector(selectHasFailed);
  const errorMessage = useSelector(selectUploadErrorMessage);

  // Use specific error message if available, otherwise use default
  const displayErrorMessage = errorMessage || LocalizedStrings.stepCompletionFileError;

  return [
    isUploading,
    `Uploading... ${uploadProgress}%`,
    hasFailed,
    displayErrorMessage,
  ];
};

export default useFileUploadStatus;
